import { gql } from "apollo-boost";


export const CREATE_CATEGORY = gql`
mutation CreateCategory($data: CategoryInput) {
    createCategory(data: $data) {
      id
    }
  }
`

export const DELETE_CATEGORY = gql`
mutation DeleteCategory($where: CategoryWhereInputOne!) {
    deleteCategory(where: $where) {
      id
    }
  }
`
export const UPDATE_CATEGORY = gql`
mutation UpdateCategory($where: CategoryWhereInputOne!, $data: CategoryInput) {
  updateCategory(where: $where, data: $data) {
    id
  }
}

`